import * as React from 'react'
import * as SwitchPrimitive from '@radix-ui/react-switch'
import { cn } from '../../lib/utils'
import { themeClasses } from '../shared/themeClasses'

const colors = {
  default: 'data-[state=checked]:bg-zinc-900 dark:data-[state=checked]:bg-zinc-100',
  accent: 'data-[state=checked]:bg-[var(--color-accent)]',
} as const

type SwitchVariant = keyof typeof colors

type SwitchProps = React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root> & {
  variant?: SwitchVariant
}

const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitive.Root>, SwitchProps>(function Switch(
  { className, variant = 'default', ...props },
  ref
) {
  return (
    <SwitchPrimitive.Root
      ref={ref}
      className={cn(themeClasses.switchTrackNeutral, 'peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-400 focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:cursor-not-allowed disabled:opacity-50 dark:focus-visible:ring-offset-zinc-950 dark:data-disabled:bg-white/15', colors[variant], className)}
      data-disabled={props.disabled ? 'true' : undefined}
      {...props}
    >
      <SwitchPrimitive.Thumb className={cn('pointer-events-none block h-5 w-5 rounded-full bg-white shadow-sm ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0 dark:bg-zinc-950')} />
    </SwitchPrimitive.Root>
  )
})

export { Switch }
